export enum ORDER_STATUS {
  NEW = 'new',
  PENDING = 'pending',
  CONFIRMED = 'confirmed',
  DECLINED = 'declined',
  SENT = 'sent',
  DELIVERED = 'delivered',
}
